export default class Testimony {
    

    static get selector() {
      return '.testimony__item';
    }
    
    constructor(el) {
        this.el = el;
        this.link = el.querySelector('.testimony__open');
        this.textClose = this.link.textContent;
        this.textOpen = this.link.dataset.textOpen;
        this.isOpen = false;

        this.setEvents();
    }

    toggle() {
        if(this.isOpen) this.close();
        else this.open();
    }
    
    open() {
        if(this.isOpen) return;
        this.el.classList.add('testimony__item--open');
        this.link.innerHTML = this.textOpen; 
        this.isOpen = true;
    }

    close() {
        if(!this.isOpen) return;
        this.el.classList.remove('testimony__item--open');
        this.link.innerHTML = this.textClose; 
        this.isOpen = false;
    }

    setEvents() {
        this.link.addEventListener('click', this.e_click.bind(this));
    }

    e_click(e) {
        e.preventDefault();
        this.toggle();
    }
   
}
